import { render, staticRenderFns } from "./VDateFiltersDesktop.vue?vue&type=template&id=d4b7c24e&"
import script from "./VDateFiltersDesktop.vue?vue&type=script&lang=js&"
export * from "./VDateFiltersDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports